import { getWindow, getDocument } from 'ssr-window';
import { id } from '../../shared/utils';
import $ from '../../shared/zmp-dom';

const fetchedModules = [];
function loadModule(moduleToLoad) {
  const ZMP = this;
  const window = getWindow();
  const document = getDocument();
  return new Promise((resolve, reject) => {
    const app = ZMP.instance;
    let modulePath;
    let moduleObj;
    let moduleFunc;
    if (!moduleToLoad) {
      reject(new Error('ZMP: Lazy module must be specified'));
      return;
    }

    function install(module) {
      ZMP.use(module);

      if (app) {
        app.useModuleParams(module, app.params);
        app.useModule(module);
      }
    }

    if (typeof moduleToLoad === 'string') {
      const matchNamePattern = moduleToLoad.match(/([a-z0-9-]*)/i);
      if (
        moduleToLoad.indexOf('.') < 0 &&
        matchNamePattern &&
        matchNamePattern[0].length === moduleToLoad.length
      ) {
        if (!app || (app && !app.params.lazyModulesPath)) {
          reject(
            new Error(
              'ZMP: "lazyModulesPath" app parameter must be specified to fetch module by name',
            ),
          );
          return;
        }
        modulePath = `${app.params.lazyModulesPath}/${moduleToLoad}/${moduleToLoad}.js`;
      } else {
        modulePath = moduleToLoad;
      }
    } else if (typeof moduleToLoad === 'function') {
      moduleFunc = moduleToLoad;
    } else {
      // considering ZMP-Plugin object
      moduleObj = moduleToLoad;
    }

    if (moduleFunc) {
      const module = moduleFunc(ZMP, false);
      if (!module) {
        reject(new Error("ZMP: Can't find ZMP component in specified component function"));
        return;
      }
      // Check if it was added
      if (ZMP.prototype.modules && ZMP.prototype.modules[module.name]) {
        resolve();
        return;
      }
      // Install It
      install(module);

      resolve();
    }
    if (moduleObj) {
      const module = moduleObj;
      if (!module) {
        reject(new Error("ZMP: Can't find ZMP component in specified component"));
        return;
      }
      // Check if it was added
      if (ZMP.prototype.modules && ZMP.prototype.modules[module.name]) {
        resolve();
        return;
      }
      // Install It
      install(module);

      resolve();
    }
    if (modulePath) {
      if (fetchedModules.indexOf(modulePath) >= 0) {
        resolve();
        return;
      }
      fetchedModules.push(modulePath);
      const scriptLoad = new Promise((resolveScript, rejectScript) => {
        ZMP.request.get(
          modulePath,
          (scriptContent) => {
            const callbackId = id();
            const callbackLoadName = `zmp_component_loader_callback_${callbackId}`;

            const scriptEl = document.createElement('script');
            scriptEl.innerHTML = `window.${callbackLoadName} = function (ZMP, ZMPAutoInstallComponent) {return ${scriptContent.trim()}}`;
            $('head').append(scriptEl);

            const componentLoader = window[callbackLoadName];
            delete window[callbackLoadName];
            $(scriptEl).remove();

            const module = componentLoader(ZMP, false);

            if (!module) {
              rejectScript(new Error(`ZMP: Can't find ZMP component in ${modulePath} file`));
              return;
            }

            // Check if it was added
            if (ZMP.prototype.modules && ZMP.prototype.modules[module.name]) {
              resolveScript();
              return;
            }

            // Install It
            install(module);

            resolveScript();
          },
          (xhr, status) => {
            rejectScript(xhr, status);
          },
        );
      });
      const styleLoad = new Promise((resolveStyle) => {
        ZMP.request.get(
          modulePath.replace('.js', app.rtl ? '.rtl.css' : '.css'),
          (styleContent) => {
            const styleEl = document.createElement('style');
            styleEl.innerHTML = styleContent;
            $('head').append(styleEl);

            resolveStyle();
          },
          () => {
            resolveStyle();
          },
        );
      });

      Promise.all([scriptLoad, styleLoad])
        .then(() => {
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    }
  });
}

export default loadModule;
